"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = require("./logger");
var LoggerModule = (function () {
    function LoggerModule(level, module) {
        this.level = level;
        this.module = module;
    }
    LoggerModule.prototype.init = function (coreInjector) {
        var logger = coreInjector.get(logger_1.Logger);
        logger.config(this.level, this.module);
        return Promise.resolve(this);
    };
    LoggerModule.prototype.getConfig = function () {
        return {
            logger: {
                level: this.level,
                module: this.module,
            }
        };
    };
    LoggerModule.prototype.terminate = function () {
        return Promise.resolve(this);
    };
    return LoggerModule;
}());
exports.LoggerModule = LoggerModule;
